/**
 * Shopify FAQ Auto-SEO Script - Final Production Version
 * Supports: HTML in answers, Retry Logic, and Universal Selectors.
 */
(function() {
  'use strict';

  // 1. Core extraction logic with HTML support
  function extractQA(rootElement) {
    if (!rootElement) return [];

    const schemaData = [];
    const potentialElements = rootElement.querySelectorAll("p, h3, h4, h5, strong, span, div, li");
    const processedNodes = new Set(); 

    potentialElements.forEach(el => {
      if (processedNodes.has(el)) return;

      const text = el.textContent.trim();
      // Regex: Matches Q: Q1: Q. (Optional question mark at end)
      const questionMatch = text.match(/^Q\d*[:\.\uff1a]\s*(.*)/i);

      if (questionMatch) {
        const questionText = questionMatch[1].trim();
        const answerParts = [];

        // Check for inline answer (A: on the same line)
        let remainingText = text.replace(questionMatch[0], "").trim();
        if (remainingText) {
          remainingText = remainingText.replace(/^A\d*[:\.\uff1a]\s*/i, "");
          answerParts.push(remainingText); 
        }

        // Search for the answer in subsequent elements
        let nextNode = el.nextElementSibling;
        
        // Handle nesting (e.g., Q is inside a <strong> tag)
        if (!nextNode && el.parentElement && ['STRONG', 'B', 'SPAN'].includes(el.tagName)) {
            nextNode = el.parentElement.nextElementSibling;
        }

        while (nextNode) {
          if (nextNode.tagName === 'H2') break; // Stop at new section

          const nextText = nextNode.textContent.trim();
          if (/^Q\d*[:\.\uff1a]/.test(nextText)) break; // Stop at next Q

          // Capture HTML content to preserve links, bolding, and lists
          if (nextNode.tagName === 'UL' || nextNode.tagName === 'OL' || nextText) {
            let htmlChunk = nextNode.outerHTML;
            // Clean "A:" prefix from HTML block if present
            htmlChunk = htmlChunk.replace(/>\s*A\d*[:\.\uff1a]\s*/i, ">");
            
            answerParts.push(htmlChunk);
            processedNodes.add(nextNode);
          }
          nextNode = nextNode.nextElementSibling;
        }

        const finalAnswer = answerParts.join(""); 
        if (questionText && finalAnswer) {
          schemaData.push({
            question: questionText,
            answer: finalAnswer
          });
        }
      }
    });

    return schemaData;
  }

  // 2. JSON-LD Injection
  function injectFaqJsonLd(qaList) {
    if (!qaList || qaList.length === 0) return false;

    // Remove existing to prevent duplicates during retries
    const existing = document.querySelector('script[data-auto-faq-script]');
    if (existing) existing.remove();

    const data = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': qaList.map(item => ({
        '@type': 'Question',
        'name': item.question,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': item.answer
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-auto-faq-script', 'true');
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    // console.log(`✅ FAQ SEO Success: Injected ${qaList.length} Q&A pairs.`);
    return true;
  }

  // 3. Smart Execution with your specific selector logic
  let retries = 0;
  function run() {
    // Priority: Product Description > Article Inner > Main > Body
    const targetContainer = document.querySelector('.product__description') || 
                            document.querySelector('.article-template-inner') || 
                            document.querySelector('main') || 
                            document.body;

    const data = extractQA(targetContainer);
    const success = injectFaqJsonLd(data);

    // If no FAQ found, retry up to 5 times (every 1 second)
    // This is crucial for Shopify themes that load content asynchronously
    if (!success && retries < 5) {
      retries++;
      setTimeout(run, 1000);
    }
  }

  // Fire as soon as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();